<template>
  <div
    class="date-picker-container date-picker-container--wide"
    tabindex="0"
    @blur="checkBlur($event)"
  >
    <div class="date-picker-calendar-view date-picker-calendar-view--wide">
      <div class="date-picker-header">
        <div class="date-picker-previous-button">
          <m-icon
            ref="datePickerPreviousButton"
            class="date-picker--no-outline"
            variant="chevron-left"
            tabindex="0"
            @click.native="updateMonth(-offsetValue)"
            @blur.native="checkBlur($event)"
          />
        </div>
        
        <div class="date-picker-header-title date-picker-header-title--left">
          {{ getHeaderCopy(0) }}
        </div>
        <div class="date-picker-header-title date-picker-header-title--right">
          {{ getHeaderCopy(1) }}
        </div>
        
        <div class="date-picker-next-button">
          <m-icon
            ref="datePickerNextButton"
            variant="chevron-right"
            class="date-picker--no-outline"
            tabindex="0"
            @click.native="updateMonth(offsetValue)"
            @blur.native="checkBlur($event)"
          />
        </div>
      </div>
      <div class="date-picker-body">
        <div class="row">
          <div class="col-6 pb-4">
            <div class="date-picker-day-container">
              <div
                v-for="day in dayList"
                :key="day"
                class="date-picker-day"
              >
                {{ day }}
              </div>
            </div>
            <div class="date-picker-content">
              <m-date-picker-day-picker
                ref="firstDayPicker"
                :previous-date-list="previousDateList[0]"
                :next-date-list="nextDateList[0]"
                :current-date-list="currentDateList[0]"
                :picker-date="pickerDate"
                :picker-month="pickerMonth"
                :picker-year="pickerYear"
                :selected-date="selectedDate"
                :selected-month="selectedMonth"
                :selected-year="selectedYear"
                :language="language"
                :disabled-dates="disabledDates"
                :is-ranged-date-picker="true"
                :id-day-picker="0"
                :hovered-date="hoveredDate"
                @update-selected-date="updateSelectedDate"
                @hovered-date="setHoveredDate"
              />
            </div>
          </div>
          <div class="col-6 pb-4">
            <div class="date-picker-day-container">
              <div
                v-for="day in dayList"
                :key="day"
                class="date-picker-day"
              >
                {{ day }}
              </div>
            </div>
            <div class="date-picker-content">
              <m-date-picker-day-picker
                ref="secondDayPicker"
                :previous-date-list="previousDateList[1]"
                :next-date-list="nextDateList[1]"
                :current-date-list="currentDateList[1]"
                :picker-date="pickerDate"
                :picker-month="pickerMonth"
                :picker-year="pickerYear"
                :selected-date="selectedDate"
                :selected-month="selectedMonth"
                :selected-year="selectedYear"
                :language="language"
                :disabled-dates="disabledDates"
                :is-ranged-date-picker="true"
                :id-day-picker="1"
                :hovered-date="hoveredDate"
                @update-selected-date="updateSelectedDate"
                @hovered-date="setHoveredDate"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MDatePickerDayPicker from '../../DatePicker/components/DatePickerDayPicker';
import MIcon from '../../Icon';
import DatePickerMixins from '../../DatePicker/mixins';
import locale from '../../DatePicker/locale';

export default {
  name: 'MDatePickerContainer',
  components: {
    MIcon,
    MDatePickerDayPicker,
  },
  mixins: [
    DatePickerMixins,
  ],
  props: {
    previousDateList: {
      type: [Array, Object],
      default: () => [],
    },
    nextDateList: {
      type: [Array, Object],
      default: () => [],
    },
    currentDateList: {
      type: [Array, Object],
      default: () => [],
    },
    pickerDate: {
      type: Array,
      default: () => [],
    },
    pickerMonth: {
      type: Array,
      default: () => [],
    },
    pickerYear: {
      type: Array,
      default: () => [],
    },
    selectedDate: {
      type: Array,
      default: () => [],
    },
    selectedMonth: {
      type: Array,
      default: () => [],
    },
    selectedYear: {
      type: Array,
      default: () => [],
    },
    language: {
      type: String,
      default: 'en',
    },
    disabledDates: {
      type: Object, 
      default: null,
    },
  },
  data: () => ({
    offsetValue: 1,
    hoveredDate: null,
  }),
  computed: {
    dayList() {
      return locale.dictionary[this.language].shortWeekdays;
    },
  },
  methods: {
    setHoveredDate(date) {
      this.hoveredDate = date ? new Date(date) : null;
    },
    pickerShortMonth(index) {
      const monthCount = 12;
      return locale.dictionary[this.language].fullMonths[this.pickerMonth[index] % monthCount];
    },
    getHeaderCopy(index) {
      return `${this.pickerShortMonth(index)} ${this.pickerYear[index]}`;
    },
    updateSelectedDate(date) {
      this.$emit('update-selected-date', date);
    },
    updateMonth(val) {
      this.$emit('update-month', val);
    },
  },
};
</script>
<style lang="scss" scoped>
.date-picker {
  &-previous-button,
  &-next-button {
    padding: 0;
    flex: 0 0 50px;
  }
  &-container {
    &--wide {
      width: 784px;
    }
  }
  &-calendar-view {
    &--wide {
      width: 784px;
    }
  }
  &-header-title {
    &--left {
      padding-right: 62px;
    }
    &--right {
      padding-left: 62px;
    }
  }
}
</style>
